import Axios from 'axios';
import {Moment} from 'moment';

export class TimeSeries {
    cache = {};

    constructor() {}

    storeFeedbackData = (URL: string, data: any) => {
        this.cache[URL] = data;
    };

    async getAggregatedUsers(
        minDate: Moment,
        maxDate: Moment,
        forceRefresh = false,
    ) {
        const URL = `/v3.0/analytics/aggregated/users?from=${minDate.unix()}&to=${maxDate.unix()}`;
        if (this.cache[URL] && !forceRefresh) {
            return {data: this.cache[URL], error: null};
        }
        const res = {
            data: null,
            error: null,
        };
        try {
            const req = await Axios.get(URL);
            res.data = req.data;
            this.storeFeedbackData(URL, req.data);
        } catch (e) {
            res.error = e;
        }

        return res;
    }
}
